import { useContext } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { Flex, Box } from 'rebass'
import SocialGroup from '../molecules/SocialGroup'
import { DonateButton } from '../atoms/Buttons'
import Arrows from '../atoms/Arrows'
import { lang } from '../../utils/lang'
import { DataContext } from '../../contexts/dataContext'
import { MediaQueries as Mq } from '../../styles/settings/theme'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { TransparentButton } from '../atoms/Buttons'
import { CgShare } from 'react-icons/cg'
import { BASE_URL } from '../../utils/constants'

const ConnectionContainer = styled(Flex)`
  position: ${(props) => (props.sm ? 'relative' : 'absolute')};
  top: 11px;
  right: ${(props) => (props.flushLeft ? 'unset' : '5px')};
  left: ${(props) => (props.flushLeft ? '5px' : 'unset')};
  align-items: center;
  justify-content: space-between;
  width: ${(props) =>
    !props.inModal ? (props.intro === 'open' ? '93%' : '100%') : '210px'};

  ${Mq.xs} {
    width: ${(props) =>
      props.sm
        ? '190px'
        : props.intro === 'open' && props.ui === 'fa'
        ? '300px'
        : props.intro === 'open' && props.ui === 'en'
        ? '270px'
        : '210px'};
    justify-content: space-between;
  }
`
const MobileFlex = styled(Flex)`
  display: ${(props) => (props.inModal ? 'none' : 'flex')};
  ${Mq.xs} {
    display: ${(props) => (props.intro === 'open' ? 'flex' : 'none')};
  }
`
//flushLeft is for when it appears in mobile modal; everywhere else it's flush right (except in fa on the intro screen!).
const ConnectionGroup = ({ sm, flushLeft, inModal }) => {
  const { ui, intro } = useContext(DataContext)
  //console.log(intro, 'intro')
  const dir = ui === 'en' ? 'ltr' : 'rtl'
  const uiLang = ui === 'fa' ? 'fa/' : ''

  return (
    <ConnectionContainer
      sm={sm}
      ml={2}
      flushLeft={flushLeft}
      intro={intro}
      ui={ui}
      inModal={inModal}
    >
      <DonateButton sm={sm}>
        <a
          href={`${BASE_URL}/${uiLang}donate`}
          target="_blank"
          rel="noreferrer"
        >
          <Flex dir={dir}>
            <Box>{lang[ui]['Donate']}</Box>
            <Box mt={'1px'} ml={ui === 'en' ? 2 : 0} mr={ui === 'en' ? 0 : 2}>
              <Arrows
                color="black"
                width={sm ? '8px' : '10px'}
                height={sm ? '10px' : '12px'}
                flip={ui === 'fa'}
              />
            </Box>
          </Flex>
        </a>
      </DonateButton>
      <SocialGroup />
      <MobileFlex pr={ui === 'en' ? '1rem' : 0} intro={intro} inModal={inModal}>
        <CopyToClipboard text={window.location.href}>
          <TransparentButton border="true" ui={ui} small="true" intro={intro}>
            <Flex alignItems="center" justifyContent="space-between">
              <CgShare color="white" />
              <div>{lang[ui]['Share']}</div>
            </Flex>
          </TransparentButton>
        </CopyToClipboard>
      </MobileFlex>
    </ConnectionContainer>
  )
}

export default ConnectionGroup

ConnectionGroup.propTypes = {
  sm: PropTypes.bool,
  flushLeft: PropTypes.bool
}
